import React, { useState } from 'react';
import { reviewAPI } from '../utils/api';
import { useNotification } from '../context/NotificationContext';

const RatingModal = ({ consultationId, onClose, onSuccess }) => {
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const { showSuccess, showError } = useNotification();

    const handleSubmit = async () => {
        if (rating === 0) {
            showError('Please select a rating');
            return;
        }

        try {
            setSubmitting(true);
            await reviewAPI.add({
                consultationId,
                rating,
                comment
            });
            showSuccess('Review submitted successfully!');
            if (onSuccess) onSuccess();
            onClose();
        } catch (error) {
            console.error(error);
            showError(error.response?.data?.message || 'Failed to submit review');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className="bg-gray-900 border border-gray-700 rounded-2xl w-full max-w-md p-6 relative animate-in fade-in zoom-in-95">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-white"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>

                <h2 className="text-2xl font-bold text-gold mb-2 text-center">Rate Session</h2>
                <p className="text-gray-400 text-center text-sm mb-6">How was your experience with the specialist?</p>

                {/* Star Rating */}
                <div className="flex justify-center gap-2 mb-6">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <button
                            key={star}
                            onClick={() => setRating(star)}
                            className="focus:outline-none transition-transform hover:scale-110"
                            type="button"
                        >
                            <svg
                                className={`w-10 h-10 ${rating >= star ? 'text-yellow-500 fill-yellow-500' : 'text-gray-600'}`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                            </svg>
                        </button>
                    ))}
                </div>

                {/* Comment */}
                <div className="mb-6">
                    <textarea
                        placeholder="Write a review (optional)..."
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        className="w-full bg-gray-800 border border-gray-700 rounded-xl p-3 text-light placeholder-gray-500 focus:border-gold focus:outline-none h-32 resize-none"
                    />
                </div>

                <button
                    onClick={handleSubmit}
                    disabled={submitting}
                    className="w-full bg-gold text-dark font-bold py-3 rounded-xl hover:bg-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                    {submitting ? 'Submitting...' : 'Submit Review'}
                </button>
            </div>
        </div>
    );
};

export default RatingModal;
